import { render, staticRenderFns } from "./KdbArticle.vue?vue&type=template&id=00635c65&"
import script from "./KdbArticle.vue?vue&type=script&lang=js&"
export * from "./KdbArticle.vue?vue&type=script&lang=js&"
import style0 from "./KdbArticle.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
